import React, { useContext } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css"; // Usa estilos de Material-UI
import { Box, styled, alpha } from "@mui/material";
import { CreatorContext } from "../../contexts/CreatorContext";

const StyledPhoneInput = styled(Box)(({ theme, creator }) => ({
	"& .react-tel-input": {
		width: "100%",
	},
	"& .form-control": {
		width: "100% !important",
		fontSize: "16px",
		fontFamily: theme.typography.fontFamily,
		borderRadius: "4px!important",
		padding: "16.5px 14px 16.5px 50px!important",
		border: `1px solid rgba(0, 0, 0, 0.2)`,
		backgroundColor: "transparent",
		outline: "none",
		height: "auto!important",
		"&:focus": {
			borderColor: theme.palette.primary.main + "!important",
			boxShadow: "0 0 0 1px " + theme.palette.primary.main + "!important",
		},
		"&:hover:not(:focus)": {
			borderColor: creator?.fontColor ?? "#000000",
		},
		"&:hover:focus": {
			borderColor: theme.palette.primary.main,
		},
	},
	"& .flag-dropdown": {
		borderRadius: "4px 0 0 4px!important",
		border: `none`,
		backgroundColor: "transparent",
		"&:hover:not(:focus)": {
			borderColor: "transparent!important",
			backgroundColor: "transparent!important",
		},
		"&:hover:focus": {
			borderColor: theme.palette.primary.main,
			backgroundColor: "transparent!important",
		},
	},
	"& .selected-flag": {
		display: "flex",
		alignItems: "center",
		padding: "0 10px",
		"&:hover": {
			borderColor: theme.palette.primary.main,
			backgroundColor: "transparent!important",
		},
	},
	"& .flag": {
		width: "23px!important",
	},
	"& .country-list": {
		fontFamily: theme.typography.fontFamily, // ✅ Aplica la fuente de MUI a la lista
		fontSize: "14px",
		backgroundColor: creator?.backgroundColor ?? "#FFFFFF",
		borderRadius: "8px",
		overflow: "hidden",
		"& .search-box": {
			marginLeft: "0px!important",
			backgroundColor: (creator?.backgroundColor ?? "#FFFFFF") + "!important",
			borderColor: alpha(creator?.fontColor ?? "#000000", 0.3) + "!important",
			color: (creator?.fontColor ?? "#000000") + "!important",
		},
		"& .search": {
			width: "100%!important",
			padding: "10px!important",
			backgroundColor: creator?.backgroundColor ?? "#FFFFFF",
		},
	},
	"& .country": {
		padding: "8px 12px",
		paddingLeft: "40px!important",
		borderBottom: `1px solid ${creator?.fontColor ?? "#000000"}!important`,
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
		},
	},
	"& .special-label": {
		display: "none !important", // ⚠️ Ocultar el label "Phone"
	},
}));

const CustomPhoneInput = ({ value, onChange, disabled }) => {
	const { creator } = useContext(CreatorContext);

	return (
		<StyledPhoneInput creator={creator}>
			<PhoneInput
				searchPlaceholder="Buscar..."
				country={"es"}
				value={value}
				onChange={onChange}
				enableSearch={true}
				placeholder="" // ⚠️ IMPORTANTE: Eliminar cualquier placeholder para que no aparezca el label
				inputProps={{
					name: "phone",
					required: true,
					"aria-label": "Teléfono", // ⚠️ Evitar que react-phone-input-2 meta un label por defecto
					autoComplete: "off",
				}}
				containerStyle={{
					width: "100%",
				}}
				inputStyle={{
					width: "100%", // Asegurar que ocupe todo el ancho
					fontSize: "14px", // Tamaño de fuente del input
					fontFamily: "Montserrat, sans-serif", // Cambiar la fuente a Montserrat
					height: "56px", // Ajustar la altura del input para coincidir con otros inputs
					paddingLeft: "70px", // Aumentar el padding para evitar el solapamiento del prefijo
					marginBottom: "16px", // Asegurar margen consistente con otros inputs
					background: creator?.backgroundColor ?? "#FFFFFF",
					borderColor: alpha(creator?.fontColor ?? "#000000", 0.3),
					color: creator?.fontColor ?? "#000000",
				}}
				buttonStyle={{
					borderRadius: "8px 0 0 8px",
					borderRight: "none",
				}}
				dropdownStyle={{
					fontSize: "14px",
					fontFamily: `'${creator?.fontFamily}', sans-serif`, // ✅ Fuente correcta en la lista
					color: creator?.fontColor,
					borderRadius: "8px",
					overflow: "auto",
				}}
				searchStyle={{
					padding: "10px 16px",
					fontFamily: `'${creator?.fontFamily}', sans-serif`,
					color: creator?.fontColor,
					width: "100%",
					backgroundColor: "#fff", // ✅ Fondo blanco
					border: "1px solid #ddd", // ✅ Borde sutil
					borderRadius: "8px", // ✅ Bordes redondeados
					fontSize: "14px", // ✅ Fuente más legible
				}}
				disabled={disabled}
			/>
		</StyledPhoneInput>
	);
};

export default CustomPhoneInput;
